import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "meetings center"
}
const _hoisted_2 = {
  key: 0,
  class: "loader-container"
}
const _hoisted_3 = { class: "schedule-meetings-container" }
const _hoisted_4 = { class: "section-header" }
const _hoisted_5 = { class: "section-title" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1 /* HOISTED */)
const _hoisted_7 = {
  key: 2,
  class: "noMeetings"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "no-meeting-message" }, "No meeting yet. Create one below to get started!", -1 /* HOISTED */)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "loader-container"
}
const _hoisted_11 = { class: "schedule-meetings-container" }
const _hoisted_12 = { class: "section-header" }
const _hoisted_13 = { class: "section-title" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1 /* HOISTED */)
const _hoisted_15 = {
  key: 2,
  class: "noMeetings"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "no-meeting-message" }, "No meeting yet. Create one below to get started!", -1 /* HOISTED */)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "btn-container meetings-bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.stage === $setup.RequestStage.MEETINGS)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode($setup["Tabs"], {
            class: "meeting-tabs",
            modelValue: $setup.tabIndex,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.tabIndex) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode($setup["Tab"], {
                counter: $setup.getScheduledMeetingLen,
                selectedTitle: "Scheduled Meetings",
                title: "Scheduled"
              }, {
                default: _withCtx(() => [
                  ($setup.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode($setup["Loader"])
                      ]))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.meetingsByMonth, (meetingObject) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("span", _hoisted_5, _toDisplayString(meetingObject.month), 1 /* TEXT */),
                            _hoisted_6
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(meetingObject.meetings, (meeting) => {
                            return (_openBlock(), _createBlock($setup["UpcomingMeeting"], {
                              meeting: meeting,
                              "onHandle:showPopup": $setup.handlePopup
                            }, null, 8 /* PROPS */, ["meeting"]))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ]))
                      }), 256 /* UNKEYED_FRAGMENT */)),
                  ($setup.noScheduledMeetings)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["counter"]),
              _createVNode($setup["Tab"], {
                counter: $setup.getHeldMeetingLen,
                selectedTitle: "Meetings Held",
                title: "Held"
              }, {
                default: _withCtx(() => [
                  ($setup.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode($setup["Loader"])
                      ]))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.heldMeetingsByMonth, (meetingObject) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("span", _hoisted_13, _toDisplayString(meetingObject.month), 1 /* TEXT */),
                            _hoisted_14
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(meetingObject.meetings, (meeting) => {
                            return (_openBlock(), _createBlock($setup["UpcomingMeeting"], {
                              meeting: meeting,
                              "onHandle:showPopup": $setup.handlePopup
                            }, null, 8 /* PROPS */, ["meeting"]))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ]))
                      }), 256 /* UNKEYED_FRAGMENT */)),
                  ($setup.noHeldMeetings)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["counter"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("button", {
              class: "borderless return",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.routeTo('')))
            }, "Back"),
            _createElementVNode("button", {
              class: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.routeTo('links')))
            }, "Meeting Types")
          ])
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.stage === $setup.RequestStage.POPUP)
      ? (_openBlock(), _createBlock($setup["meetingPopup"], {
          key: 1,
          selectedMeeting: $setup.selectedMeeting,
          onClosePopup: $setup.closePopup
        }, null, 8 /* PROPS */, ["selectedMeeting"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}